import { PushpinFilled, SafetyCertificateFilled, SafetyCertificateOutlined } from '@ant-design/icons';
import { Tag } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next';

export const PhoneView = (props: {primaryPhone : string, additionalPhones : string[], setEdit?: any, strike?: boolean}) => {
  const { t } = useTranslation();

  
  return (
    <div className="phone-box" onClick={()=>props.setEdit(true)}>
      {props.strike ?
      <>            
            <del style={{ marginTop: "1em", display: "flex", justifyContent: "flex-start" }}>
                <p style={{ color: "darkred" }}>
                    {props.primaryPhone} <PushpinFilled/>
                </p>
              </del>
            {
              props.additionalPhones && props.additionalPhones.map((additionalPhone: string, i:number) => (
                <del style={{ color: "darkred" }} key={i}>
                    {additionalPhone}
                </del>
              ))
            }
      </>
      :
      <>
            <div style={{ marginTop: "1em", display: "flex", justifyContent: "flex-start" }}>
                <p style={{ color: "slategrey" }}>
                    {props.primaryPhone} <Tag>{t('dictionary.principal').toUpperCase()}</Tag>
                </p>
              </div>
            {
              props.additionalPhones && props.additionalPhones.map((additionalPhone: string, i:number) => (
                <p style={{ color: "slategrey" }} key={i}>
                    {additionalPhone}
                </p>
              ))
            }
      </>
      }      
    </div>
  )
}
